import { useShop } from "hooks";
import { createElement, Fragment, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import routes from "routes";
import { useDispatch } from "react-redux";
import { syncCart } from "store/cart/actions";
import { useCart } from "hooks";
function App() {
  const { isLoggedIn } = useShop();
  const { items, subTotal, discount, coupon, totalQuantity } = useCart();
  const dispatch = useDispatch();
  useEffect(() => {
    if (isLoggedIn) {
      // Dispatch sync to server
      dispatch(syncCart(items));
    }
  }, [isLoggedIn, dispatch]);
  return (
    <BrowserRouter>
      <Routes>
        {routes.publicRoutes.map((route, idx) => (
          <Fragment key={idx}>
            <Route path={route.path} element={createElement(route.component)} />
          </Fragment>
        ))}

        {routes.protectedRoutes.map((route, idx) => {
          return (
            <Fragment key={idx}>
              <Route
                path={route.path}
                // element={createElement(route.component)}
                element={
                  isLoggedIn ? (
                    createElement(route.component)
                  ) : (
                    <Navigate to="/" replace />
                  )
                }
              />
            </Fragment>
          );
        })}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
